import { render, staticRenderFns } from "./UpdateStatusSclForm.vue?vue&type=template&id=0001d648&"
import script from "./UpdateStatusSclForm.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusSclForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports